import { businessAdminService } from '../../../shared/services';
import { InviteEmployee } from '../../../shared/components/SconApp/InviteEmployee';

interface IProps {
  businessId: number;
  onCloseEdit: () => void;
  isReceptionist?: boolean;
}

export const BusinessEmployeesSconApp: React.FC<IProps> = ({ businessId, onCloseEdit, isReceptionist }) => {
  return (
    <InviteEmployee
      title={isReceptionist ? 'Nova recepcionista SconApp' : 'Novo profissional SconApp'}
      inviteFn={(email) => businessAdminService.inviteEmployee(businessId, email, isReceptionist)}
      onCloseEdit={onCloseEdit}
      buttonLabel='Enviar convite'
    />
  );
};
